(function () {
  var HTML = document.documentElement;
  var BODY = document.body;
  var MOUNT_ID = 'cart-drawer-host';
  var TEMPLATE_IDS = {
    control: 'cart-drawer-template-control',
    v1: 'cart-drawer-template-v1',
  };
  var UPCART_BODY_CLASSES = ['upcartPopupShow', 'upcart-open', 'upcart-drawer-open'];
  var UPCART_EXTERNAL_SELECTOR = [
    '#UpcartPopup',
    '#CartPopup',
    '#UpcartPopupBackDrop',
    '#CartPopupBackDrop',
    '#upcart',
    '#upCart',
    '#upCartStickyButton',
    '.upcart-cart',
    '.upcart-wrapper',
    '.upcart-drawer',
    '.upcart-popup',
    '.upcart-backdrop',
    '[id*="upcart" i]',
    '[class*="upcart" i]',
  ].join(',');

  var mount = null;
  var currentMode = undefined;
  var nativeAddInFlight = false;
  var upCartSuppressionObserver = null;
  var upCartSuppressionQueued = false;
  var suppressingUpCart = false;

  function normalizeMode(value) {
    if (!value) return null;

    var normalized = String(value).toLowerCase().replace(/[\s_]/g, '-');

    if (normalized === 'control' || normalized === 'a' || normalized === '0') {
      return 'control';
    }

    if (
      normalized === 'v1' ||
      normalized === 'variation' ||
      normalized === 'variation-1' ||
      normalized === 'variant-1' ||
      normalized === 'b' ||
      normalized === '1' ||
      normalized === 'native'
    ) {
      return 'v1';
    }

    return null;
  }

  function getModeFromQuery() {
    if (!window.location || !window.location.search) return null;

    var query = new URLSearchParams(window.location.search);
    var raw =
      query.get('cart-exp') ||
      query.get('cartExp') ||
      query.get('cart-mode') ||
      query.get('cartMode') ||
      query.get('cm_exp') ||
      query.get('ccexp');

    return normalizeMode(raw);
  }

  function getModeFromRoot() {
    if (!HTML || !BODY) return null;

    var explicit =
      normalizeMode(HTML.getAttribute('data-cart-exp')) ||
      normalizeMode(BODY.getAttribute('data-cart-exp')) ||
      normalizeMode(HTML.getAttribute('data-cart-mode')) ||
      normalizeMode(BODY.getAttribute('data-cart-mode'));

    if (explicit) return explicit;

    if (HTML.classList.contains('cart-exp-control')) return 'control';
    if (HTML.classList.contains('cart-exp-v1') || HTML.classList.contains('cro-v1')) return 'v1';

    return null;
  }

  function resolveMode() {
    return getModeFromQuery() || getModeFromRoot();
  }

  function isExperimentMode(mode) {
    return mode === 'v1' || mode === 'control';
  }

  function isExperimentActive() {
    return isExperimentMode(currentMode);
  }

  function setRootData(name, value) {
    if (!HTML || !HTML.dataset) return;

    if (value) {
      if (HTML.dataset[name] !== value) HTML.dataset[name] = value;
    } else if (HTML.dataset[name] !== undefined) {
      delete HTML.dataset[name];
    }
  }

  function toggleRootClass(name, enabled) {
    if (!HTML || !HTML.classList) return;
    if (HTML.classList.contains(name) !== enabled) {
      HTML.classList.toggle(name, enabled);
    }
  }

  function publishMode(mode) {
    var assignment = mode === 'control' || mode === 'v1' ? mode : null;
    var active = isExperimentMode(mode);
    var isV1 = mode === 'v1';

    setRootData('cartExp', assignment);
    setRootData('cartMode', assignment);

    toggleRootClass('cart-exp-active', active);
    toggleRootClass('cart-exp-control', mode === 'control');
    toggleRootClass('cart-exp-v1', isV1);
    toggleRootClass('cro-v1', isV1);

    window.CatchmasterCartMode = {
      mode: assignment,
      exp: assignment,
      isActive: active,
      isNative: active,
      variant: assignment,
      rootClass: isV1 ? 'cart-exp-v1' : (mode === 'control' ? 'cart-exp-control' : ''),
    };

    if (active) {
      startUpCartSuppressionObserver();
      suppressUpCart();
    } else {
      stopUpCartSuppressionObserver();
    }
  }

  function dispatchModeEvent(name, detail) {
    var event;
    if (typeof CustomEvent === 'function') {
      event = new CustomEvent(name, { detail: detail || null });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(name, true, true, detail || null);
    }
    document.dispatchEvent(event);
  }

  function isInsideExperimentMount(element) {
    var host = mount || document.getElementById(MOUNT_ID);
    return !!(host && element && (element === host || host.contains(element)));
  }

  function isExternalUpCartElement(element) {
    if (!element || element.nodeType !== 1 || !element.matches) return false;
    if (element === HTML || element === BODY || isInsideExperimentMount(element)) return false;

    var tagName = element.tagName;
    if (/^(HEAD|SCRIPT|STYLE|LINK|META|TEMPLATE|NOSCRIPT)$/.test(tagName)) return false;

    return element.matches(UPCART_EXTERNAL_SELECTOR);
  }

  function removeExternalUpCartElement(element) {
    if (!isExternalUpCartElement(element)) return false;

    element.setAttribute('aria-hidden', 'true');
    element.setAttribute('hidden', '');
    element.style.setProperty('display', 'none', 'important');
    element.style.setProperty('visibility', 'hidden', 'important');
    element.style.setProperty('pointer-events', 'none', 'important');

    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }

    return true;
  }

  function suppressExternalUpCartNodes(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var removed = 0;
    var nodes = [];

    if (root && root.nodeType === 1) nodes.push(root);

    if (scope && scope.querySelectorAll) {
      Array.prototype.forEach.call(scope.querySelectorAll(UPCART_EXTERNAL_SELECTOR), function (node) {
        nodes.push(node);
      });
    }

    nodes.forEach(function (node) {
      if (removeExternalUpCartElement(node)) removed += 1;
    });

    return removed;
  }

  function suppressUpCart() {
    if (!BODY || suppressingUpCart) return 0;

    suppressingUpCart = true;
    var removed = 0;

    try {
      UPCART_BODY_CLASSES.forEach(function (className) {
        if (BODY.classList.contains(className)) {
          BODY.classList.remove(className);
        }
      });

      removed += suppressExternalUpCartNodes(document);
      return removed;
    } finally {
      suppressingUpCart = false;
    }
  }

  function scheduleUpCartSuppression() {
    if (upCartSuppressionQueued) return;

    upCartSuppressionQueued = true;
    var run = function () {
      upCartSuppressionQueued = false;
      suppressUpCart();
    };

    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(run);
    } else {
      window.setTimeout(run, 0);
    }
  }

  function startUpCartSuppressionObserver() {
    if (upCartSuppressionObserver || !window.MutationObserver || !BODY) return;

    upCartSuppressionObserver = new MutationObserver(function (mutations) {
      if (suppressingUpCart || !isExperimentActive()) return;

      var shouldSuppress = false;

      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.target === BODY) {
          shouldSuppress = true;
        }

        if (mutation.type === 'childList' && mutation.addedNodes && mutation.addedNodes.length) {
          shouldSuppress = true;
        }
      });

      if (shouldSuppress) scheduleUpCartSuppression();
    });

    upCartSuppressionObserver.observe(BODY, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });
  }

  function stopUpCartSuppressionObserver() {
    if (!upCartSuppressionObserver) return;

    upCartSuppressionObserver.disconnect();
    upCartSuppressionObserver = null;
    upCartSuppressionQueued = false;
  }

  function getTemplate(mode, doc) {
    var sourceDocument = doc || document;
    var templateId = TEMPLATE_IDS[mode];
    if (!templateId) return null;

    return sourceDocument.getElementById(templateId);
  }

  function setDrawerClosedState(drawer) {
    if (!drawer) return;

    drawer.classList.remove('active');
    drawer.style.setProperty('visibility', 'hidden', 'important');
    drawer.style.setProperty('pointer-events', 'none', 'important');
  }

  function replaceMount(mode) {
    if (!mount) return null;

    if (!isExperimentMode(mode)) {
      mount.innerHTML = '';
      return null;
    }

    var existingDrawer = mount.querySelector('cart-drawer');
    if (currentMode === mode && existingDrawer && existingDrawer.getAttribute('data-cart-variant') === mode) {
      return existingDrawer;
    }

    var template = getTemplate(mode);
    if (!template || !template.content) return null;

    mount.innerHTML = '';
    mount.appendChild(template.content.cloneNode(true));

    var drawer = mount.querySelector('cart-drawer');
    setDrawerClosedState(drawer);
    return drawer;
  }

  function ensureActiveDrawer() {
    if (!isExperimentActive()) return null;

    var drawer = mount && mount.querySelector('cart-drawer');
    if (drawer) return drawer;

    return replaceMount(currentMode);
  }

  function findCartAddForm(target) {
    if (!target || !target.closest) return null;

    if (target.getAttribute) {
      var formId = target.getAttribute('form');
      var linkedForm = formId && document.getElementById(formId);
      if (linkedForm && linkedForm.matches && linkedForm.matches('form[action*="/cart/add"]')) {
        return linkedForm;
      }
    }

    var form = target.closest('form[action*="/cart/add"]');
    if (form) return form;

    var productForm = target.closest('product-form');
    return productForm && productForm.querySelector('form[action*="/cart/add"]');
  }

  function setSubmitLoading(trigger, loading) {
    if (!trigger) return;

    trigger.classList.toggle('loading', loading);
    if (loading) {
      trigger.setAttribute('aria-disabled', 'true');
    } else {
      trigger.removeAttribute('aria-disabled');
    }

    var productForm = trigger.closest && trigger.closest('product-form');
    var spinner = productForm && productForm.querySelector('.loading-overlay__spinner');
    if (spinner) {
      spinner.classList.toggle('hidden', !loading);
    }
  }

  function submitNativeCartAdd(form, trigger) {
    if (!form || nativeAddInFlight) return;

    var drawer = ensureActiveDrawer();
    if (!drawer) return;

    nativeAddInFlight = true;
    setSubmitLoading(trigger, true);

    var formData = new FormData(form);

    if (typeof drawer.getSectionsToRender === 'function') {
      formData.append('sections', drawer.getSectionsToRender().map(function (section) { return section.id; }));
      formData.append('sections_url', window.location.pathname);
      if (typeof drawer.setActiveElement === 'function') {
        drawer.setActiveElement(trigger || document.activeElement);
      }
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) throw response;

        suppressUpCart();
        scheduleUpCartSuppression();
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(response);
        } else if (window.routes && window.routes.cart_url) {
          window.location.assign(window.routes.cart_url);
        }
      })
      .catch(function (error) {
        console.error(error);
        if (error && error.description) {
          var errEl = document.getElementById('CartDrawer-CartErrors');
          if (errEl) {
            errEl.textContent = error.description;
            return;
          }
        }
        if (window.routes && window.routes.cart_url) {
          window.location.assign(window.routes.cart_url);
        }
      })
      .finally(function () {
        nativeAddInFlight = false;
        setSubmitLoading(trigger, false);
      });
  }

  function onNativeCartAdd(event) {
    if (!isExperimentActive()) return;

    var form;
    var trigger;

    if (event.type === 'submit') {
      // Real form submission (Enter key, programmatic submit): match by the
      // form itself, not by hunting for a button descendant.
      form = event.target && event.target.matches && event.target.matches('form[action*="/cart/add"]') ? event.target : null;
      if (!form) return;
      trigger = form.querySelector('[type="submit"], button[name="add"]');
    } else {
      // Click: only hijack clicks that actually land on the add-to-cart
      // control. Without this, any click on a form-associated element
      // (variant radios, quantity steppers, labels) that merely resolves to
      // a /cart/add form via findCartAddForm's `form` attribute lookup gets
      // treated as an add-to-cart submit of the currently selected variant,
      // which also preventDefault()s the click and blocks the variant
      // selection itself.
      trigger = event.target && event.target.closest && event.target.closest('button[name="add"], input[name="add"], .product-form__submit');
      if (!trigger) return;
      form = findCartAddForm(trigger);
      if (!form) return;
    }

    event.preventDefault();
    if (event.stopPropagation) event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    suppressUpCart();
    submitNativeCartAdd(form, trigger);
  }

  function openNativeDrawer(event, trigger) {
    if (!isExperimentActive() || !trigger) return;

    event.preventDefault();
    if (event.stopPropagation) event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    var drawer = ensureActiveDrawer();
    if (!drawer) {
      if (window.routes && window.routes.cart_url) {
        window.location.assign(window.routes.cart_url);
      }
      return;
    }

    suppressUpCart();
    if (typeof drawer.open === 'function') {
      drawer.open(trigger);
    } else if (typeof drawer.showModal === 'function') {
      drawer.showModal();
    }
  }

  function onCartTrigger(event) {
    if (!isExperimentActive()) return;

    var trigger = event.target && event.target.closest(
      '#cart-icon-bubble, .header__icon--cart'
    );
    if (!trigger || (trigger.closest && trigger.closest('cart-drawer'))) return;

    if (event.type === 'keydown') {
      var key = event.key;
      if (key !== 'Enter' && key !== ' ' && key !== 'Spacebar') return;
    }

    openNativeDrawer(event, trigger);
  }

  function updateMode() {
    var nextMode = resolveMode();
    if (nextMode === currentMode) {
      if (isExperimentActive()) {
        publishMode(nextMode);
        suppressUpCart();
      }
      return;
    }

    var previous = currentMode;
    publishMode(nextMode);
    currentMode = nextMode;
    replaceMount(currentMode);

    dispatchModeEvent('catchmaster:cart-mode-changed', {
      previous: previous || null,
      current: currentMode || null,
    });
    dispatchModeEvent('catchmaster:cart-mode-signal');
  }

  function bindTriggerInterceptors() {
    if (window._catchmasterCartInterceptorsBound) return;
    window._catchmasterCartInterceptorsBound = true;
    document.addEventListener('click', onCartTrigger, true);
    document.addEventListener('keydown', onCartTrigger, true);
    document.addEventListener('click', onNativeCartAdd, true);
    document.addEventListener('submit', onNativeCartAdd, true);
  }

  function observeModeSignals() {
    if (!window.MutationObserver || !HTML) return;

    var observer = new MutationObserver(function () {
      updateMode();
    });

    observer.observe(HTML, {
      attributes: true,
      attributeFilter: ['class', 'data-cart-exp', 'data-cart-mode'],
    });

    document.addEventListener('catchmaster:cart-mode-signal', updateMode);
  }

  function bootstrap() {
    HTML = document.documentElement;
    BODY = document.body;
    mount = document.getElementById(MOUNT_ID);

    updateMode();
    bindTriggerInterceptors();
    observeModeSignals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
